import { FullLoadingIndicator } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

import { LAST_PATHNAME } from '../common/constants';

export const Login: React.FunctionComponent = () => {
  const { isAuthenticated, user, signinRedirect } = useAuth();
  const [isLoginComplete, setIsLoginComplete] = React.useState<boolean>(false);

  useEffect(() => {
    const login = async () => {
      await signinRedirect();
      setIsLoginComplete(true);
    };

    if (!user || !user.access_token || !isAuthenticated) {
      login();
    } else {
      setIsLoginComplete(true);
    }
  }, []);

  if (!isLoginComplete) {
    return <FullLoadingIndicator hidden={false} underHeader={true} />;
  }

  const redirectHash = localStorage.getItem(LAST_PATHNAME) || '/home';

  return <Navigate to={redirectHash} />;
};
